import moment from 'moment';

import { swarmRequest } from '@common/helpers/util/requestMiddleware';

export const loadTransactionHistory = (start, end) => (
  swarmRequest({
    where: {
      from_date: moment(start).startOf('D').unix(),
      to_date: moment(end).endOf('D').unix(),
    },
    product: 'Casino',
  }, 'balance_history_v2').then((data) => data?.details)
);
